import useLinkedInSwitchAccountStep from './useLinkedInSwitchAccountStep';

export default useLinkedInSwitchAccountStep;
